const resetFieldStyles = `
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  outline: none;
  border: 0px;
  margin: 0px;
  padding: 0px;
  background-color: transparent;
  width: 100%;`;
export const makeInputText = ({ theme, before, variant = 'darken', size = 'medium', isActive, isDisabled }) => {
    return `
  ${resetFieldStyles}
  height: ${theme.form.size[size].height};
  line-height: ${theme.form.size[size].lineHeight};
  font-size: ${theme.form.size[size].fontSize};
  font-family: ${theme.fonts.families.primary};
  color: ${theme.form.variant[variant].color};

  /**
   *  Estilos de cuando seleccionamos una opcion del autocomplete del input
   **/

  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus,
  &:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 30px ${theme.form.variant[variant].idle.backgroundColor} inset !important;
  }
  
  /**
   * Arrows en input number
   **/
  
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  
  &[type=number] {
    -moz-appearance: textfield;
  }`;
};
export const makeCustomSup = () => {
    return `color: red;`;
};
